import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { aTipoOracion } from "../../../../../../utils/texto";

const SessionSequenceTable = ({
  data,
  loadingGeneral,
  regenerandoId,
  competenciasDisponibles,
  loadingCompetencias,
  onMoveRow,
  onCompetenciaChange,
  onOpenDescription,
  onConfirmRegenerateRow,
  onEditRow,
}) => (
  <Box sx={{ position: "relative" }}>
    <TableContainer component={Paper} className="step4-table">
      <Table size="small" className="step4-table-inner">
        <TableHead className="step4-thead">
          <TableRow>
            <TableCell className="step4-th" />
            <TableCell className="step4-th">N° Sesión</TableCell>
            <TableCell className="step4-th">Sesión de Aprendizaje</TableCell>
            <TableCell className="step4-th">Descripción</TableCell>
            <TableCell className="step4-th">Competencia</TableCell>
            <TableCell className="step4-th" align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, index) => (
            <TableRow key={row.id || row.nroSesion} className="step4-tr">
              <TableCell className="step4-td step4-td-order">
                <IconButton size="small" disabled={loadingGeneral || index === 0} onClick={() => onMoveRow(index, "up")} className="step4-order-btn">
                  <ArrowUpwardIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" disabled={loadingGeneral || index === data.length - 1} onClick={() => onMoveRow(index, "down")} className="step4-order-btn">
                  <ArrowDownwardIcon fontSize="small" />
                </IconButton>
              </TableCell>

              <TableCell className="step4-td step4-td-nro">Sesión {row.nroSesion}</TableCell>
              <TableCell className="step4-td step4-td-tema">{row.tema}</TableCell>

              <TableCell className="step4-td step4-td-desc">
                <Typography className="step4-desc-preview">{row.descripcion}</Typography>
                {row.descripcion?.length > 180 && (
                  <Button size="small" sx={{ mt: 0.5, px: 0, minWidth: "auto", fontSize: 11 }} onClick={() => onOpenDescription(row)}>
                    Ver más
                  </Button>
                )}
              </TableCell>

              <TableCell className="step4-td step4-td-competencia">
                <TextField
                  select
                  fullWidth
                  size="small"
                  value={String(row.competencia || "")}
                  onChange={(event) =>
                    onCompetenciaChange(
                      row,
                      event.target.value
                    )
                  }
                  disabled={
                    loadingGeneral ||
                    loadingCompetencias ||
                    regenerandoId ===
                      (row.id || row.nroSesion)
                  }
                  SelectProps={{ native: true }}
                  helperText={
                    !row.competencia
                      ? "No se identificó una competencia en el documento"
                      : row.competenciaOrigen === "USUARIO"
                        ? "Elegida por el usuario; cambiarla conserva el contenido"
                        : "Identificada automáticamente; cambiarla conserva el contenido"
                  }
                >
                  <option value="" disabled>
                    Seleccione una competencia
                  </option>
                  {!competenciasDisponibles.some(
                    (item) =>
                      Number(item.id) ===
                      Number(row.competencia)
                  ) && row.competencia && (
                    <option value={row.competencia}>
                      {row.competenciaNombre
                        ? aTipoOracion(row.competenciaNombre)
                        : `Competencia ${row.competencia}`}
                    </option>
                  )}
                  {competenciasDisponibles.map(
                    (competencia) => (
                      <option
                        key={competencia.id}
                        value={competencia.id}
                      >
                        {aTipoOracion(competencia.nombre)}
                      </option>
                    )
                  )}
                </TextField>
              </TableCell>

              <TableCell className="step4-td step4-td-actions">
                <Box className="step4-actions-wrapper" align="center">
                  <Button
                    size="small"
                    startIcon={regenerandoId === (row.id || row.nroSesion) ? <CircularProgress size={14} /> : <AutorenewIcon fontSize="small" />}
                    disabled={loadingGeneral || regenerandoId === (row.id || row.nroSesion)}
                    onClick={() => onConfirmRegenerateRow(row)}
                    className="step4-action-inline"
                  >
                    {regenerandoId === (row.id || row.nroSesion) ? "Regenerando..." : "Regenerar"}
                  </Button>

                  <Box
                    title={
                      loadingGeneral
                        ? "No disponible mientras se regeneran todos los temas"
                        : regenerandoId === (row.id || row.nroSesion)
                          ? "Esta sesión se está regenerando"
                          : ""
                    }
                  >
                    <Button
                      size="small"
                      startIcon={<EditIcon fontSize="small" />}
                      onClick={() => onEditRow(row)}
                      disabled={loadingGeneral || regenerandoId === (row.id || row.nroSesion)}
                      className="step4-action-inline step4-action-edit"
                    >
                      Editar
                    </Button>
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    {loadingGeneral && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(255,255,255,0.65)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10,
          borderRadius: 1,
        }}
      >
        <CircularProgress />
      </Box>
    )}
  </Box>
);

export default SessionSequenceTable;
